import { render, staticRenderFns } from "./cardTemplateVip11.vue?vue&type=template&id=da36858c&scoped=true&"
import script from "./cardTemplateVip11.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip11.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip11.vue?vue&type=style&index=0&id=da36858c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36858c",
  null
  
)

export default component.exports